import React from 'react'
import { Drawer } from '@surecompanies/core_components'

import type { AllocationTicket } from '../../api/transaction-details-api-client'
import { DASH, formatDate, formatMonth } from './helpers'
import styles from './TicketDrawer.module.scss'

/**
 * Right-side "Tickets" drawer opened from the Ticket column's icon button —
 * lists the tickets for the clicked row (parent = all allocations, child/
 * plain = that allocation only). Styled after ReconciliationV2's
 * ActivityLogDrawer (entry cards, --rv2-* tokens) rather than the design
 * mock's bespoke drawer markup.
 */

const DRAWER_WIDTH = 420

export interface TicketDrawerProps {
  open: boolean
  tickets: AllocationTicket[]
  onClose: () => void
}

const TicketDrawer: React.FC<TicketDrawerProps> = ({
  open,
  tickets,
  onClose,
}) => (
  <Drawer
    open={open}
    onClose={onClose}
    placement="right"
    width={DRAWER_WIDTH}
    title={<span className={styles.headerTitle}>Tickets</span>}
    styles={{
      header: { padding: '22px 24px 18px' },
      body: { padding: 0 },
    }}
  >
    {tickets.length === 0 ? (
      <div className={styles.emptyWrap}>
        <span className={styles.emptyText}>No tickets linked.</span>
      </div>
    ) : (
      <div className={styles.list}>
        {tickets.map((ticket) => (
          <div className={styles.card} key={ticket.ticketUrl}>
            <div className={styles.cardTitle}>
              Ticket #{ticket.ticketId ?? 'ticket'}
            </div>
            <div className={styles.fieldGrid}>
              <div className={styles.field}>
                <span className={styles.fieldLabel}>Coverage month</span>
                <span className={styles.fieldValue}>
                  {formatMonth(ticket.periodStartDate)}
                </span>
              </div>
              <div className={styles.field}>
                <span className={styles.fieldLabel}>Created</span>
                <span className={styles.fieldValue}>
                  {formatDate(ticket.createdAt)}
                </span>
              </div>
              <div className={`${styles.field} ${styles.fieldFull}`}>
                <span className={styles.fieldLabel}>Note</span>
                <span className={styles.fieldValue}>{ticket.note || DASH}</span>
              </div>
            </div>
            <a
              href={ticket.ticketUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.ticketLink}
            >
              Open in Zendesk
            </a>
          </div>
        ))}
      </div>
    )}
  </Drawer>
)

export default TicketDrawer
